import type { PageSegmentLoadMetric } from '@atlassian/browser-metrics/page-segment-load';

import { createPageSegmentLoadMetric } from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import { OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY } from '@confluence/browser-metrics/entry-points/metric-keys.ts';

export const OBJECT_SIDEBAR_CONTROL_METRIC: PageSegmentLoadMetric = createPageSegmentLoadMetric({
	key: OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY,
	ssr: window.__SSR_RENDERED__ ? { doneAsFmp: true } : undefined,
});
